import React, { useEffect, useState } from 'react';
import './splash-screen.scss';

interface SplashScreenProps {
  onComplete: () => void;
  gender?: 'male' | 'female' | null; // null = default splash, 'male'/'female' = specific splash
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete, gender = null }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 1025);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 1025);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getSplashImage = () => {
    if (!isLargeScreen) {
      if (gender === 'male') return 'new/logo-new.png';
      if (gender === 'female') return '/woman-presenting.jpeg';
      return '/new/splash.png';
    } else {
      if (gender === 'male') return 'new/AMEEN-AR.jpeg';
      if (gender === 'female') return '/woman-presenting.jpeg';
      return '/new/splash.png';
    }
  };

  const splashImage = '/new/splash.png';

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      onComplete();
    }, 4000);
    return () => clearTimeout(timer);
  }, [onComplete, gender]);

  if (!isVisible) return null;

  return (
    <div
      className={`splash-screen${gender === null ? ' splash-screen--opening' : ''}`}
      style={{
        backgroundImage: `url(${splashImage})`,
        backgroundSize: gender === null ? 'cover' : '100% 115%',
      }}
    >
      {/* الصورة كخلفية فقط */}
    </div>
  );
};

export default SplashScreen;